import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "flex items-center justify-between gap-3" }
const _hoisted_3 = { class: "flex items-center gap-5" }
const _hoisted_4 = {
  key: 0,
  class: "px-2 py-1 bg-green-500 text-white rounded-lg border"
}
const _hoisted_5 = {
  key: 1,
  id: "tips",
  class: "group w-fit flex !justify-start lg:!justify-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle cursor-pointer text-white bg-h-warning-400 px-1 !text-xl rounded-full hover:scale-75 transition-all animate-bounce-short" }, null, -1)
const _hoisted_7 = { class: "hidden absolute transition-all group-hover:flex group-focus:flex bg-white p-3 w-64 mt-8 rounded-lg !z-50 shadow-md border overflow-hidden break-words whitespace-normal" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "flex gap-2" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "flex items-center gap-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle !text-3xl text-h-warning-400" }, null, -1)
const _hoisted_13 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_VideoComponent = _resolveComponent("VideoComponent")!
  const _component_Image = _resolveComponent("Image")!
  const _component_PDFComponent = _resolveComponent("PDFComponent")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", null, [
      (_ctx.loaderStore.load[5])
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            loader: _ctx.loaderStore.load[5]
          }, null, 8, ["loader"]))
        : (_ctx.storeMaterial.currentMaterial?.file)
          ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
              _createElementVNode("header", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h5", null, _toDisplayString(_ctx.storeMaterial.currentMaterial.name), 1),
                  (_ctx.isDone)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString("Concluído")))
                    : _createCommentVNode("", true),
                  (!_ctx.isDone && _ctx.storeMaterial.isVideo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("p", { innerHTML: 
                  'O material do tipo <b>vídeo só será considerado concluído</b>, se o aluno <b>assistir pelo menos 90%</b> de seu conteúdo.'
                 }, null, 8, _hoisted_8)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Button, {
                    icon: "pi pi-chevron-left",
                    class: "btn-primary",
                    onClick: _withModifiers(_ctx.storeNavigation.prev, ["prevent"])
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_Button, {
                    icon: "pi pi-chevron-right",
                    class: "btn-primary",
                    disabled: _ctx.storeNavigation.isNextDisabled,
                    onClick: _withModifiers(_ctx.storeNavigation.next, ["prevent"])
                  }, null, 8, ["disabled", "onClick"])
                ])
              ]),
              (_ctx.storeMaterial.isVideo)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(`${_ctx.flex} mt-4 flex-col z-10`)
                  }, [
                    _createVNode(_component_VideoComponent, {
                      data: _ctx.storeMaterial.currentMaterial?.file,
                      idVideo: _ctx.storeMaterial.currentMaterial?.file?.id,
                      startTime: _ctx.time,
                      isAdaptativeLearning: false,
                      ref: "videoComponent"
                    }, null, 8, ["data", "idVideo", "startTime"])
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.storeMaterial.isImage)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(`${_ctx.flex} mt-4`)
                  }, [
                    _createVNode(_component_Image, {
                      src: _ctx.storeMaterial.currentMaterial?.file?.url,
                      alt: "material-image",
                      imageClass: "w-full h-[100%] sm:h-[600px] lg:h-[600px] object-cover",
                      preview: ""
                    }, null, 8, ["src"])
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.storeMaterial.isAudio)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: _normalizeClass(`${_ctx.flex} mt-4`)
                  }, [
                    _createElementVNode("audio", {
                      id: "material-audio",
                      src: _ctx.storeMaterial.currentMaterial?.file?.url,
                      class: "w-full h-[100%] sm:h-[600px] lg:h-[600px]"
                    }, null, 8, _hoisted_10)
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.storeMaterial.isPdf)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    class: _normalizeClass(`${_ctx.flex} mt-4`)
                  }, [
                    _createVNode(_component_PDFComponent, {
                      url: _ctx.storeMaterial.currentMaterial?.file?.url
                    }, null, 8, ["url"])
                  ], 2))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showAlert,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showAlert) = $event)),
      draggable: false,
      breakpoints: { '960px': '95vw', '640px': '95vw' },
      style: { width: '25vw', minWidth: '360px' },
      modal: ""
    }, {
      header: _withCtx(() => [
        _createElementVNode("section", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("labels.generic", { pt: `Alerta`, en: `Alert` })), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", {
          class: "text-xl",
          innerHTML: 
        'O material do tipo <b>vídeo só será considerado concluído</b>, se o aluno <b>assistir pelo menos 90%</b> de seu conteúdo.'
      
        }, null, 8, _hoisted_13)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}